export enum StateStatus {
	"idle",
	"fetching",
	"error"
}
